import { z } from 'zod';
/**
 * Delete Tenant User Request Schema
 * DELETE /api/v2/tenants/:tenantId/users/:userId
 * URL parameters for identifying the tenant user to delete
 */ export const DeleteTenantUserRequestSchema = z.object({
    tenantId: z.string(),
    userId: z.string()
});
/**
 * Delete Tenant User Response Schema
 * Returned on successful tenant user deletion
 */ export const DeleteTenantUserResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-tenant-user.schema.js.map